import { createSlice }                       from "@reduxjs/toolkit";

import { developerApi }                      from "src/store/services/developer/";
import type { IGetDeveloperProfileResponse } from "src/store/services/developer/interfaces/responses.interface";
import type { RootState }                    from "src/store/store";
import { RequestStateEnum }                  from "src/types";

type TDeveloperState = {
  value: IGetDeveloperProfileResponse;
  state: RequestStateEnum;
};

const initialState: TDeveloperState = {
  value: {
    id             : 0,
    name           : "",
    title          : "",
    description    : "",
    avatar         : "",
    location       : "",
    local_time     : "",
    experienceYears: 0,
    workingDays    : 0,
    rate           : "",
    availability   : "",
    status         : "",
    skills         : [],
    languages      : [],
    cv             : "",
    reporterId     : "",
  },
  state: RequestStateEnum.NODATA,
};

const slice = createSlice({
  name         : "developersProfile",
  initialState,
  reducers     : {},
  extraReducers: (builder) => {
    builder.addMatcher(developerApi.endpoints.getDeveloperProfile.matchPending,
      (state) => {
        state.state = RequestStateEnum.LOADING;
      });
    builder.addMatcher(developerApi.endpoints.getDeveloperProfile.matchRejected,
      (state) => {
        state.state = RequestStateEnum.FAILED;
      });
    builder.addMatcher(developerApi.endpoints.getDeveloperProfile.matchFulfilled,
      (state, { payload }) => {
        state.state = RequestStateEnum.FULLFILLED;
        state.value = payload;
      });
  },
});

export const selectDevelopersData = (state: RootState) =>
  state.developersProfile;

export const { reducer: developersProfileReducer } = slice;
